<app-stages [stages]='stages' currentStage='Zajęcia'></app-stages>
<br>
@if (!pending() && !loading()) {
  @if (roadOccupations().length) {
    <app-accordion-group>
      @for (occupation of roadOccupations(); track $index) {
        <app-accordion-item [disabled]="showItemForm" [name]="occupation | occupationLabel: $index">
          <app-occupation-preview [occupation]='occupation'>
          </app-occupation-preview>
          <span slot='action'>
            <button
              (click)='onEditOccupations($event, $index)'
              class='btn btn-secondary icon-btn'
              title='Edytuj'
              [disabled]='showItemForm'>
              <i class='fa fa-pencil-alt'></i>
            </button>
            &nbsp;
            <button
              type='button'
              class='btn btn-red-secondary icon-btn'
              title='Usuń z listy'
              [disabled]='showItemForm'
              (click)='onRemove($index, $event)'>
              <i class='fa fa-trash-alt'></i>
            </button>
          </span>
        </app-accordion-item>
      }
    </app-accordion-group>
  } @else {
    <app-alert alertTitle="Brak dodanych zajęć!" [closable]="false"></app-alert>
  }
  @if (showItemForm) {
    <div class='gov-card'>
      <div class='gov-card__header'>
        Dodanie zajęcia
      </div>
      <div class='gov-card__body'>
        <app-road-occupation-form
          [workPurposeControlType]="workPurposeControlType"
          [showCancel]="true"
          [edit]='currentIndex() !== undefined'
          [form]='form'
          (onCancel)='showItemForm = false'
          (onSubmit)='onUpdateOccupations($event)'>
        </app-road-occupation-form>
      </div>
    </div>
    <br>
  } @else {
    <br>
    <div class='d-flex justify-content-end'>
      <button type='button' class='btn btn-primary' (click)='onAdd()'>
        {{ roadOccupations().length ? "Dodaj kolejne zajęcie" : "Dodaj zajęcie" }}
      </button>
    </div>
    <br>
  }
  <div class='application-actions'>
    <button
      type='button'
      class='btn btn-secondary'
      (click)='onCancel()'>
      <span>
        Wstecz
      </span>
    </button>
    <button
      [disabled]='showItemForm || pending()'
      type='button'
      class='btn btn-primary'
      (click)='submitAndGoNext()'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
}
@if (pending()) {
  <app-spinner>
    Poczekaj trwa zapisywania danych...
  </app-spinner>
}
@if (loading()) {
  <app-spinner>
    Poczekaj trwa ładowanie danych...
  </app-spinner>
}
